"use strict";
/**
 * Game constants shared between client and server.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinType = exports.GameEndReason = exports.GameStatus = exports.TIMEOUT_GRACE_PERIOD_MS = exports.DEBUG_TIMEOUT_MS = exports.TURN_TIMEOUT_MS = exports.CLIENT_CONNECTION_CHECK_INTERVAL_MS = exports.EMOTE_IDS = exports.EMOTE_COOLDOWN_MS = exports.CLIENT_HEARTBEAT_TIMEOUT_MS = exports.HEARTBEAT_INTERVAL_MS = exports.TOTAL_POINTS = exports.CHECKER_COUNT = exports.HOME_BOARD_BLACK_END = exports.HOME_BOARD_BLACK_START = exports.HOME_BOARD_WHITE_END = exports.HOME_BOARD_WHITE_START = exports.OFF_INDEX_BLACK = exports.OFF_INDEX_WHITE = exports.BAR_INDEX_BLACK = exports.BAR_INDEX_WHITE = exports.PLAYER_BLACK = exports.PLAYER_WHITE = void 0;
// Player constants
exports.PLAYER_WHITE = "white";
exports.PLAYER_BLACK = "black";
// Board index constants
exports.BAR_INDEX_WHITE = -1;
exports.BAR_INDEX_BLACK = 24;
// Bear off index constants - where checkers go when bearing off
exports.OFF_INDEX_WHITE = -1; // White bears off to index -1
exports.OFF_INDEX_BLACK = 24; // Black bears off to index 24
// Home board boundaries - where checkers must be to bear off
exports.HOME_BOARD_WHITE_START = 0;
exports.HOME_BOARD_WHITE_END = 5;
exports.HOME_BOARD_BLACK_START = 18;
exports.HOME_BOARD_BLACK_END = 23;
// Game constants
exports.CHECKER_COUNT = 15;
exports.TOTAL_POINTS = 24;
// Heartbeat and connection monitoring constants
exports.HEARTBEAT_INTERVAL_MS = 20000; // 20 seconds (server-side)
exports.CLIENT_HEARTBEAT_TIMEOUT_MS = 25000; // 25 seconds (client-side) - interval + 5s buffer
// Emote System
exports.EMOTE_COOLDOWN_MS = 3000; // 3 seconds between emotes
exports.EMOTE_IDS = ["thumbs_up", "laugh", "thinking", "bad_luck", "angry", "heart"];
exports.CLIENT_CONNECTION_CHECK_INTERVAL_MS = 5000; // 5 seconds (client-side) - how often to check connection health
// Turn timing constants
exports.TURN_TIMEOUT_MS = 60000; // 60 seconds per turn
exports.DEBUG_TIMEOUT_MS = 60000; // modify this for development/testing
// Timeout grace period - server adds this to actual timeout but doesn't report it to clients
// This prevents the visual timer from having time left when the timeout fires
exports.TIMEOUT_GRACE_PERIOD_MS = 1000; // 1 second grace period
// Game status constants
exports.GameStatus = {
    SETUP: "SETUP",
    IN_PROGRESS: "IN_PROGRESS",
    FINISHED: "FINISHED"
};
// Game end reason constants
exports.GameEndReason = {
    NORMAL: "NORMAL",
    TIMEOUT_FORFEIT: "TIMEOUT_FORFEIT",
    DOUBLE_DECLINED: "DOUBLE_DECLINED",
    RESIGNATION: "RESIGNATION"
};
// Win type constants
exports.WinType = {
    REGULAR: "REGULAR",
    GAMMON: "GAMMON",
    BACKGAMMON: "BACKGAMMON"
};
//# sourceMappingURL=index.js.map